import { Filesystem, Directory } from '@capacitor/filesystem';
import { Share } from '@capacitor/share';
import Device from '../utilities/Device';
/** Delay before the download's object URL is released — an immediate revoke can cancel the download. */
const REVOKE_DELAY_MS = 10000;
/**
 * Hands a PDF to the user: on Android / iOS it is written to the app cache and
 * the system share sheet opens (save to Files, send through any app); on web
 * and Electron the browser downloads it. Resolves false only when the file
 * could not be handed over — closing the share sheet is not a failure.
 */
export async function savePdfFile(base64, fileName) {
    const name = /\.pdf$/i.test(fileName) ? fileName : `${fileName}.pdf`;
    try {
        if (Device.isMobile()) {
            const file = await Filesystem.writeFile({ path: name, data: base64, directory: Directory.Cache });
            try {
                await Share.share({ title: name, url: file.uri, dialogTitle: name });
            }
            catch (error) {
                if (!/cancel/i.test(String(error?.message ?? error)))
                    throw error;
            }
            return true;
        }
        const bytes = Uint8Array.from(atob(base64), character => character.charCodeAt(0));
        const url = URL.createObjectURL(new Blob([bytes], { type: 'application/pdf' }));
        const anchor = document.createElement('a');
        anchor.href = url;
        anchor.download = name;
        document.body.appendChild(anchor);
        anchor.click();
        anchor.remove();
        setTimeout(() => URL.revokeObjectURL(url), REVOKE_DELAY_MS);
        return true;
    }
    catch (error) {
        console.error('Saving the PDF failed', error);
        return false;
    }
}
//# sourceMappingURL=pdfFile.js.map